import React from 'react';
import { scrollToSection, scrollToTop } from '../../utils/scrollUtils';
import { useTranslation } from 'react-i18next';


import { 
    SidebarContainer, 
    Icon, 
    CloseIcon,
    SidebarWrapper,
    SidebarMenu,
    SidebarLink,
    SideRedesWrap,
    SidebarRoute

} from './SidebarElements';
import { FaFacebook, FaInstagram } from 'react-icons/fa';




function Sidebar({ isOpen, toggle }) {

    const { t } = useTranslation();

    const handleClick = (section, offsetY) => {
        scrollToSection(section, offsetY); // Rola para a seção desejada
        toggle(); // Fecha o Sidebar
    };
    

    return (
        <SidebarContainer isOpen={isOpen} onClick={toggle}>
        <Icon onClick={scrollToTop}>
            <CloseIcon />
        </Icon>
        <SidebarWrapper>

            <SidebarMenu>
                <SidebarLink onClick={() => {handleClick('historia', 80)}}>
                    {t('nav.historia')}
                </SidebarLink>
                <SidebarLink onClick={() => {handleClick('ambiente', 80)}}>
                    {t('nav.ambiente')}
                </SidebarLink> 
                <SidebarLink onClick={() => {handleClick('culinaria', 80)}}>
                    {t('nav.culinaria')}
                </SidebarLink>
                <SidebarLink onClick={() => {handleClick('fotos', 80)}}>
                    {t('nav.fotos')}
                </SidebarLink>
                <SidebarLink onClick={() => {handleClick('cardapio', 80)}}>
                    {t('nav.menu')}
                </SidebarLink>
            </SidebarMenu>

            <SideRedesWrap>
                <SidebarRoute target="blank" to="https://www.facebook.com/varandasbonitoms/"><FaFacebook /></SidebarRoute>
                <SidebarRoute target="blank" to="https://www.instagram.com/varandasbonitoms"><FaInstagram /></SidebarRoute>
            </SideRedesWrap>

            
        </SidebarWrapper>

      
    </SidebarContainer>
  )
}

export default Sidebar;
